import { css } from 'styled-components';
import type { FloatingButtonContainerProps } from '../FloatingButton';

export const buttonTransform = ({
  _position,
  _verticalOffset,
  _horizontalOffset,
  _iconOnly
}: FloatingButtonContainerProps) => {
  if (
    _position === 'top-left' ||
    _position === 'top-right' ||
    _position === 'bottom-right' ||
    _position === 'bottom-left'
  ) {
    if (!_iconOnly && _verticalOffset !== 0 && _horizontalOffset === 0) {
      return cornerStickyPosition[_position];
    }
  }

  if (_position === 'left' || _position === 'right') {
    if (!_iconOnly) {
      return leftRightStickyPosition[_position];
    }

    return css`
      transform: translateY(50%);
    `;
  }

  if (_position === 'top' || _position === 'bottom') {
    return topBottomStickyPosition[_position];
  }

  return;
};

const cornerStickyPosition = {
  'top-left': css`
    transform-origin: top left;
    transform: rotate(270deg) translateX(-100%);
  `,
  'top-right': css`
    transform-origin: top right;
    transform: rotate(270deg) translateY(-100%);
  `,
  'bottom-right': css`
    transform-origin: bottom right;
    transform: rotate(270deg) translateX(100%);
  `,
  'bottom-left': css`
    transform-origin: bottom left;
    transform: rotate(270deg) translateY(100%);
  `
};

const leftRightStickyPosition = {
  left: css`
    transform: rotate(270deg) translate(-50%, 100%);
    transform-origin: bottom left;
  `,
  right: css`
    transform: rotate(270deg) translateX(50%);
    transform-origin: bottom right;
  `
};

const topBottomStickyPosition = {
  top: css`
    transform: translateX(50%);
  `,
  bottom: css`
    transform: translateX(50%);
  `
};
